<template>
  <v-navigation-drawer
    :value="isAddUpdateProductSidebarActive"
    temporary
    touchless
    floating
    stateless
    :right="!$vuetify.rtl"
    :width="$vuetify.breakpoint.smAndUp ? 700 : '100%'"
    app
    :class="$vuetify.breakpoint.smAndUp ? 'rounded-tl-xl rounded-bl-xl' : null"
    @input="val => $emit('update:is-add-update-product-sidebar-active', val)"
  >
    <v-sheet
      :color="isDark ? '#363351' : '#fafafa'"
      class="pa-3 d-flex align-center justify-space-between"
    >
      <div class="d-flex align-center">
        <v-avatar
          size="48"
          color="secondary"
        >
          <v-icon
            size="24"
            class="white--text"
          >
            {{ formIcon }}
          </v-icon>
        </v-avatar>
        <div class="text-h6 font-weight-medium ml-3">
          {{ formTitle }}
        </div>
      </div>
      <v-btn
        icon
        x-small
        @click="$emit('update:is-add-update-product-sidebar-active', false)"
      >
        <v-icon> {{ icons.mdiClose }}</v-icon>
      </v-btn>
    </v-sheet>

    <form>
      <validation-observer ref="observer">
        <v-row no-gutters>
          <v-col
            cols="12"
            md="6"
          >
            <!-- Başlık -->
            <v-text-field
              v-model="productData.baslik"
              filled
              :dark="isDark"
              label="Mamül Adı"
              disabled
              hide-details
              class="rounded-0"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <!-- Mamül Kodu -->
            <v-text-field
              v-model="productData.urun_kodu"
              filled
              :dark="isDark"
              disabled
              label="Mamül Kodu"
              hide-details
              class="rounded-0"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <!-- Mamül Kodu -->
            <v-text-field
              v-model="productData.sira"
              filled
              :dark="isDark"

              label="Sıra"
              hide-details
              class="rounded-0"
            ></v-text-field>
          </v-col>
        </v-row>

        <validation-provider
          v-slot="{ errors }"
          tag="div"
          mode="eager"
          name="Kategori"
          rules="required"
        >
          <v-autocomplete
            v-model="productData.kategori"
            filled
            dark
            hide-details
            :menu-props="{ bottom: true, offsetY: true }"
            :items="kategorilerItems"
            class="rounded-0"
            :error-messages="errors"
            label="Kategori"
          >
          </v-autocomplete>
        </validation-provider>
        <v-row no-gutters>
          <v-col
            cols="12"
            md="3"
          >
            <!-- Satış Fiyatı -->
            <v-text-field
              v-model="productData.satis_fiyati"
              filled
              :dark="isDark"
              label="Fiyat"
              hide-details
              class="rounded-0"
              disabled
              suffix="TL"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <!-- Birim -->
            <v-select
              v-model="productData.birim"
              filled
              :items="$store.state.tanimlar.birim"
              :menu-props="{ bottom: true, offsetY: true }"
              :dark="isDark"
              label="Birim"
              disabled
              hide-details
              class="rounded-0"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <!-- Birim -->
            <v-text-field
              v-model="productData.birim_ritmi"
              filled
              :dark="isDark"
              label="Katsayı"
              hide-details
              class="rounded-0"
              disabled
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-select
              v-model="productData.kdv_orani"
              filled
              :dark="isDark"
              :items="$store.state.tanimlar.kdv"
              :menu-props="{ bottom: true, offsetY: true }"
              label="KDV"
              disabled
              hide-details
              class="rounded-0"
            ></v-select>
          </v-col>
        </v-row>

        <v-select
          v-model="productData.harici_musteriler"
          filled
          dark
          hide-details
          :menu-props="{ bottom: true, offsetY: true }"
          :items="hariciMagzalarItems"
          class="rounded-0"
          label="Harici Mağazalar"
          multiple
        >
          <template v-slot:prepend-item>
            <v-list-item @click="toggle">
              <v-list-item-action>
                <v-icon>
                  {{ icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Tüm Mağazaları Seç </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip
              color="chip"
              small
              label
            >
              <span>{{ item.text }}</span>
            </v-chip>
          </template>
        </v-select>
      </validation-observer>
    </form>

    <template v-slot:append>
      <v-container fluid>
        <v-row>
          <v-col cols="6">
            <v-btn
              rounded
              block
              text
              @click="$emit('update:is-add-update-product-sidebar-active', false)"
            >
              Vazgeç
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              x-large
              rounded
              block
              :loading="loading"
              color="secondary"
              @click="submit"
            >
              {{ formButtonText }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </v-navigation-drawer>
</template>

<script>
import useAppConfig from '@core/@app-config/useAppConfig'
import {
mdiCheckboxBlankOutline, mdiClose,
mdiCloseBox, mdiEye,
mdiEyeOff,
mdiFileTree, mdiMinusBox, mdiPencil,
mdiPlusThick
} from '@mdi/js'

import store from '@/store'
import { onMounted, ref } from '@vue/composition-api'
import Vue from 'vue'

export default {
  model: {
    prop: 'isAddUpdateProductSidebarActive',
    event: 'update:is-add-update-product-sidebar-active',
  },
  props: {
    isAddUpdateProductSidebarActive: {
      type: Boolean,
      required: true,
    },
    productType: {
      type: String,
      required: true,
    },
    productItem: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isDark } = useAppConfig()
    const kategorilerItems = ref([])
    const hariciMagzalarItems = ref([])

    onMounted(() => {
      store
        .dispatch('postMethod', {
          method: 'adminCategoryList',
          'search[t.ust]': 2,
        })
        .then(response => {
          const kategoriler = response.response.result.map(item => ({
            text: item.kategori,
            value: item.id,
          }))
          kategorilerItems.value = kategoriler
        })
        .catch(e => {
          Vue.swal({
            title: 'Hata',
            text: e.message,
            width: '350px',
            icon: 'error',
            background: '#FF4C51',
            showCloseButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#cc3d41',
          })
        })

      store
        .dispatch('postMethod', {
          method: 'getCustomers',
          'search[u.custtype]': 'BAYILIST',
        })
        .then(response => {
          const harici_musteriler = response.response.result.map(item => ({
            text: item.officename,
            value: item.customer,
          }))
          hariciMagzalarItems.value = harici_musteriler
        })
        .catch(e => {
          Vue.swal({
            title: 'Hata',
            text: e.message,
            width: '350px',
            icon: 'error',
            background: '#FF4C51',
            showCloseButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#cc3d41',
          })
        })
    })

    return {
      isDark,
      kategorilerItems,
      hariciMagzalarItems,
      icons: {
        mdiClose,
        mdiEyeOff,
        mdiEye,
        mdiPlusThick,
        mdiPencil,
        mdiFileTree,
        mdiCloseBox,
        mdiMinusBox,
        mdiCheckboxBlankOutline,
      },
    }
  },
  data: () => ({
    loading: false,
    productData: {
      aktif: '1',
      sira: null,
      harici_musteriler: [],
      baslik: '',
      urun_kodu: '',
      kategori: '',
      birim_ritmi: '',
      birim: '',
      satis_fiyati: '',
      kdv_orani: '',
    },
    defaultItem: {
      aktif: '1',
      sira: null,
      harici_musteriler: [],
      baslik: '',
      urun_kodu: '',
      kategori: '',
      birim_ritmi: '',
      birim: '',
      satis_fiyati: '',
      kdv_orani: '',
    },
  }),

  computed: {
    likesAllFruit() {
      return this.productData?.harici_musteriler?.length === this.hariciMagzalarItems.length
    },
    likesSomeFruit() {
      return this.productData?.harici_musteriler?.length > 0 && !this.likesAllFruit
    },
    icon() {
      if (this.likesAllFruit) return this.icons.mdiCloseBox
      if (this.likesSomeFruit) return this.icons.mdiMinusBox

      return this.icons.mdiCheckboxBlankOutline
    },
    formTitle() {
      return this.productType === 'add' ? 'Yeni Mamül Ekle' : 'Mamül Düzenle'
    },
    formIcon() {
      return this.productType === 'add' ? this.icons.mdiPlusThick : this.icons.mdiPencil
    },
    formButtonText() {
      return this.productType === 'add' ? 'Kaydet' : 'Güncelle'
    },
  },

  watch: {
    isAddUpdateProductSidebarActive(val) {
      if (val && this.productType === 'edit') {
        this.$nextTick(() => {
          this.productData = {
            aktif: 1,
            id: this.productItem?.id,
            sira: this.productItem?.sira,
            baslik: this.productItem?.baslik,
            urun_kodu: this.productItem?.urun_kodu,
            kategori: this.productItem?.kategori_id,
            birim_ritmi: this.productItem?.birim_ritmi,
            birim: this.productItem?.birim,
            satis_fiyati: this.productItem?.satis_fiyati,
            kdv_orani: this.productItem?.kdv_orani,
            harici_musteriler: this.productItem?.harici_musteriler?.split(',') || null,
          }
        })
      }
      if (!val) {
        this.close()
      }
    },
  },

  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.productData.harici_musteriler = []
        } else {
          this.productData.harici_musteriler = this.hariciMagzalarItems.slice()
        }
      })
    },

    async submit() {
      this.loading = true
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.loading = false

        Vue.swal({
          title: 'Hata',
          text: 'Lütfen kırımızı alanları doldurun',
          icon: 'error',
          timer: 2000,
          background: '#FF4C51',
          timerProgressBar: true,
          showConfirmButton: false,
        })

        return
      }

      const data = this.productData

      const { id } = this.productItem

      const search = ['baslik']
      const method = 'saveProduct'
      this.$store
        .dispatch('addUpdateMethod', {
          data,
          search,
          method,
          id,
        })
        .then(response => {
          if (response.error) {
            Vue.swal({
              title: 'Hata',
              text: response.msg,
              icon: 'error',
              timer: 2000,
              background: '#FF4C51',
              timerProgressBar: true,
              showConfirmButton: false,
            })
          } else {
            this.$emit('refetch-data')
            this.$emit('update:is-add-update-product-sidebar-active', false)

            if (!this.productItem.id) {
              this.$emit('upload-image', { id: response.response.insertId })
            }
            this.$emit('save-product-event', {
              message: `${this.productData.baslik} Mamül Eklendi`,
              color: 'success',
              timeout: 5000,
            })
            this.loading = false
          }
        })
        .catch(e => {
          Vue.swal({
            title: 'Hata',
            text: e.message,
            width: '350px',
            icon: 'error',
            background: '#FF4C51',
            showCloseButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#cc3d41',
          })
          this.$emit('update:is-add-update-product-sidebar-active', false)

          this.loading = false
        })
    },
    close() {
      this.$refs.observer.reset()
      this.$nextTick(() => {
        this.productData = { ...this.defaultItem }
      })
    },
  },
}
</script>

<style lang="scss">
.multiSelect {
  .v-select__selections {
    padding-bottom: 15px !important;
    padding-top: 35px !important;
  }
}
</style>
